// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-contextmenu {
    min-width: 160px;
    padding: 5px 0;
    margin: 2px 0 0;
    font-size: 14px;
    color: #fff;
    text-align: left;
    background-color: #143852;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.15);
    border-radius: .35rem;
    outline: none;
    opacity: 0;
    pointer-events: none;
    transition: opacity 250ms ease !important;
    z-index: 100;
    -webkit-box-shadow: -4px 5px 4px 1px rgba(0,0,0,0.21); 
    box-shadow: -4px 5px 4px 1px rgba(0,0,0,0.21);
}

.react-contextmenu.react-contextmenu--visible {
    opacity: 1;
    pointer-events: auto;
}

.react-contextmenu-item {
    padding: 3px 20px;
    font-weight: 400;
    line-height: 1.5;
    color: #fff;
    text-align: inherit;
    white-space: nowrap;
    background: 0 0;
    border: 0;
	cursor: pointer;
}

.react-contextmenu-item.react-contextmenu-item--active,
.react-contextmenu-item.react-contextmenu-item--selected {
    color: #fff;
    background-color: #20a0ff;
    border-color: #20a0ff;
    text-decoration: none;
}

.react-contextmenu-item.react-contextmenu-item--disabled,
.react-contextmenu-item.react-contextmenu-item--disabled:hover {
    color: #878a8c;
    background-color: transparent;
    border-color: rgba(0,0,0,.15);
}

.react-contextmenu-item--divider {
    margin-bottom: 3px;
    padding: 2px 0;
    border-bottom: 1px solid rgba(0,0,0,.15);
    cursor: inherit;
}
.react-contextmenu-item--divider:hover {
    background-color: transparent;
    border-color: rgba(0,0,0,.15);
}

.react-contextmenu-item.react-contextmenu-submenu {
	padding: 0;
}

.react-contextmenu-item.react-contextmenu-submenu > .react-contextmenu-item {
}

.react-contextmenu-item.react-contextmenu-submenu > .react-contextmenu-item:after {
    content: "▶";
    display: inline-block;
    position: absolute;
    right: 7px;
}

.example-multiple-targets::after {
    content: attr(data-count);
    display: block;
}`, "",{"version":3,"sources":["webpack://./logician_coder/static/css/react-contextmenu.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,4BAA4B;IAC5B,iCAAiC;IACjC,qBAAqB;IACrB,aAAa;IACb,UAAU;IACV,oBAAoB;IACpB,yCAAyC;IACzC,YAAY;IACZ,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;CACZ,eAAe;AAChB;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;;IAEI,cAAc;IACd,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,wCAAwC;IACxC,eAAe;AACnB;AACA;IACI,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;CACC,UAAU;AACX;;AAEA;AACA;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB","sourcesContent":[".react-contextmenu {\n    min-width: 160px;\n    padding: 5px 0;\n    margin: 2px 0 0;\n    font-size: 14px;\n    color: #fff;\n    text-align: left;\n    background-color: #143852;\n    background-clip: padding-box;\n    border: 1px solid rgba(0,0,0,.15);\n    border-radius: .35rem;\n    outline: none;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 250ms ease !important;\n    z-index: 100;\n    -webkit-box-shadow: -4px 5px 4px 1px rgba(0,0,0,0.21); \n    box-shadow: -4px 5px 4px 1px rgba(0,0,0,0.21);\n}\n\n.react-contextmenu.react-contextmenu--visible {\n    opacity: 1;\n    pointer-events: auto;\n}\n\n.react-contextmenu-item {\n    padding: 3px 20px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #fff;\n    text-align: inherit;\n    white-space: nowrap;\n    background: 0 0;\n    border: 0;\n\tcursor: pointer;\n}\n\n.react-contextmenu-item.react-contextmenu-item--active,\n.react-contextmenu-item.react-contextmenu-item--selected {\n    color: #fff;\n    background-color: #20a0ff;\n    border-color: #20a0ff;\n    text-decoration: none;\n}\n\n.react-contextmenu-item.react-contextmenu-item--disabled,\n.react-contextmenu-item.react-contextmenu-item--disabled:hover {\n    color: #878a8c;\n    background-color: transparent;\n    border-color: rgba(0,0,0,.15);\n}\n\n.react-contextmenu-item--divider {\n    margin-bottom: 3px;\n    padding: 2px 0;\n    border-bottom: 1px solid rgba(0,0,0,.15);\n    cursor: inherit;\n}\n.react-contextmenu-item--divider:hover {\n    background-color: transparent;\n    border-color: rgba(0,0,0,.15);\n}\n\n.react-contextmenu-item.react-contextmenu-submenu {\n\tpadding: 0;\n}\n\n.react-contextmenu-item.react-contextmenu-submenu > .react-contextmenu-item {\n}\n\n.react-contextmenu-item.react-contextmenu-submenu > .react-contextmenu-item:after {\n    content: \"▶\";\n    display: inline-block;\n    position: absolute;\n    right: 7px;\n}\n\n.example-multiple-targets::after {\n    content: attr(data-count);\n    display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
